import { render, staticRenderFns } from "./ScreenPhotoPopup.vue?vue&type=template&id=32ec2e60&"
import script from "./ScreenPhotoPopup.vue?vue&type=script&lang=ts&"
export * from "./ScreenPhotoPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports